const { recordRoboGBIEvent, PAGE_PRODUCT, RELIABLE } = require('utilities/uTagging');
const { getIsOwner } = require('utilities/jointHolders/holderTypes');
const { FIRST_OWNER } = require('constants/holders/holderTypes');

const UtagHelper = {
    getJointHolderInfoFromUserProfile(userProfile) {
        const jointHolderInfo = {};
        jointHolderInfo.isJointHolderAccount = 'no';
        jointHolderInfo.typeHolder = FIRST_OWNER;
        jointHolderInfo.typeUserHolder = '';
        if (userProfile.isJointHolderAccount) {
            jointHolderInfo.isJointHolderAccount = 'si';
            if (userProfile.jointHolderType) {
                jointHolderInfo.typeHolder = getIsOwner(userProfile.jointHolderType)
                    ? FIRST_OWNER
                    : userProfile.jointHolderType;
                if (!getIsOwner(jointHolderInfo.jointHolderType)) {
                    jointHolderInfo.isJointHolderAccount = '';
                    jointHolderInfo.typeUserHolder = userProfile.isJointHolderNoClient ? 'no cliente' : 'cliente';
                }
            }
        }

        return jointHolderInfo;
    },

    getJointHolderInfoFromInvite(invite, isAlreadyClient = '') {
        const jointHolderInfo = {};
        jointHolderInfo.isJointHolderAccount = '';
        jointHolderInfo.typeHolder = invite.jointHolderType;
        jointHolderInfo.typeUserHolder = isAlreadyClient;

        return jointHolderInfo;
    },

    recordEventRoboGBI(pathForTag = '', eventCategory = '', eventAction = '', eventDetail = '', userProfile) {
        const { recordId, userId, identityMethod, investmentType } = userProfile;
        recordRoboGBIEvent(
            pathForTag,
            PAGE_PRODUCT,
            eventCategory,
            eventAction,
            eventDetail,
            recordId,
            userId,
            RELIABLE[identityMethod],
            investmentType ? investmentType : ''
        );
    },
};

module.exports = UtagHelper;
